import { useEffect, useState } from "react";
import {fetchAnalysisDataList} from "../../../api/analysisApi"
import { fetchSensorCount } from "../../../api/homeApi";
import { toast } from "react-toastify";



function useFetchAnalysisList(filter,pageSize,currentPage,order_by,order_dir) {
    const [data, setData] = useState({
        analysisList: [],
        analysisCount: 0
    });
    let offset = (currentPage - 1) * pageSize;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    console.log("filter in analysis hook",filter)
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                console.log("inside try")
                const [sensorResponse, countResponse] = await Promise.all([
                    fetchAnalysisDataList(filter, order_by, order_dir),
                    fetchSensorCount(filter),
                ]);
                console.log("sensorResponse", sensorResponse);
                console.log("countResponse", countResponse);
                setData({
                    analysisList: sensorResponse,
                    analysisCount: countResponse,
                });
            } catch (err) {
                toast.error("Cannot fetch Sensor List");
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [currentPage, order_by, filter])

    return { data, loading, error };

}


export default useFetchAnalysisList;